module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "main"
  }, [(_vm.access_token == '') ? [_c('loginForm', {
    on: {
      "onLogin": _vm.sendAuth
    }
  })] : [_c('home', {
    attrs: {
      "onLogout": _vm.onLogout
    }
  })]], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-30542548","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Main.vue
// module id = 539
// module chunks = 1